import {http} from '@services/utils';

import {
  type GetScopedTokenRequest,
  type GetScopedTokenResponse,
  GetScopedTokenResponseSchema,
} from './getScopedToken.schema';

/**
 * GET `auth/token?permissionId=X` — обмен general-токена на scoped.
 *
 * Side effect (грант доступа), вызывается один раз при выборе
 * permission'а. Используется через `useMutation`, без `.query.ts`.
 */
export const getScopedToken = async ({
  permissionId,
}: GetScopedTokenRequest): Promise<GetScopedTokenResponse> => {
  const raw = await http('auth/token', {params: {permissionId}});
  return GetScopedTokenResponseSchema.parse(raw);
};
